import React__default from 'react';
import { toSpacingAttributes } from '../layouts/Spacing/spacing.js';
import './ListViewRow.scss';

const ListViewRow = ({ leadingAccessory, title, titleMetadata, itemMetadata, itemActions, className, leftContent, bottomContent, rightContent, padding, }) => {
    return (React__default.createElement("li", { "data-rev-component": 'list-view-row', className: className, ...toSpacingAttributes('p', padding) },
        React__default.createElement("div", { className: 'list-view-row-container--rev' },
            React__default.createElement("div", { className: 'list-view-row-title-content--rev' },
                leadingAccessory ||
                    (leftContent && (React__default.createElement("div", { className: 'list-view-row-leading-accessory--rev' }, leadingAccessory || leftContent))),
                title && React__default.createElement("div", { className: 'list-view-row-title--rev' }, title),
                titleMetadata && (React__default.createElement("div", { className: 'list-view-row-title-metadata--rev' }, titleMetadata))),
            React__default.createElement("div", { className: 'list-view-row-item-content--rev' },
                itemMetadata && (React__default.createElement("div", { className: 'list-view-row-item-metadata--rev' }, itemMetadata)),
                itemActions && React__default.createElement("div", { className: 'list-view-row-actions--rev' }, itemActions),
                rightContent)),
        bottomContent && (React__default.createElement("div", { className: 'list-view-row-bottom-content--rev' }, bottomContent))));
};

export { ListViewRow };
//# sourceMappingURL=ListViewRow.js.map
